import Draft from './Draft';

export default Draft;
